
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SendSmsOptions {
  phoneNumber: string;
  message: string;
  tag?: string;
}

export const useSmsSender = () => {
  const [isLoading, setIsLoading] = useState(false);

  const sendSms = async ({ phoneNumber, message, tag = 'verification' }: SendSmsOptions) => {
    setIsLoading(true);
    
    try {
      console.log(`Sending SMS to ${phoneNumber}`);
      
      const { data, error } = await supabase.functions.invoke('send-sms', {
        body: { phoneNumber, message, tag }
      });
      
      if (error) {
        console.error('Error sending SMS:', error);
        alert('Impossible d\'envoyer le SMS. Veuillez réessayer.');
        return { success: false, error };
      }
      
      console.log('SMS sent successfully:', data);
      return { success: true, data };
    } catch (error) {
      console.error('Error in sendSms:', error);
      alert('Une erreur est survenue lors de l\'envoi du SMS.');
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Unknown error' 
      };
    } finally {
      setIsLoading(false);
    }
  };
  
  return {
    sendSms,
    isLoading
  };
};
